<div class="venue-seat-plan" *ngIf="seatPlanImage" (click)="openSeatPlanModal()">
  <h3 class="seat-plan-title">
    <span>{{ 'ticket.labels.seeVenueSeatingPlan' | translate }}</span>
    <mat-icon>zoom_in</mat-icon>
  </h3>
  <div class="seat-plan-image">
    <img [src]="seatPlanImageUrl" (error)="onImageError($event)" loading="lazy" alt="Seat Plan">
  </div>
</div>
